import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/chigua/SiteLayout";
import Home from "@/pages/home/page";
import ChannelList from "@/pages/list/page";
import StoryDetail from "@/pages/story/page";
import About from "@/pages/about/page";
import Contact from "@/pages/contact/page";
import Search from "@/pages/search/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/list/:slug", element: <ChannelList /> },
      { path: "/story/:slug", element: <StoryDetail /> },
      { path: "/about", element: <About /> },
      { path: "/contact", element: <Contact /> },
      { path: "/search", element: <Search /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;